<form>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="useSkillURL">
         <input
            type="checkbox"
            id="useSkillURL"
            [checked]="useSkillURL$ | async"
            (click)="changeSkillUrl($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.web_viewer.settings.use_skill_url' | translate }}
      </label>
   </div>

   <div *ngIf="!(useSkillURL$ | async)" class="sam-form-row">
      <label>{{ 'brick.brick_definitions.web_viewer.settings.url_title_label' | translate }}</label>
      <div class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width">
         <input
            kendoTextBox
            placeholder="{{ 'brick.brick_definitions.web_viewer.settings.url_title_label' | translate }}"
            fxFlex="1 1 *"
            [value]="tagDrivenURL$ | async"
            (debouncedInput)="tagDrivenUrlTextChanged($event.target.value)"
            debouncedInputDelay="750"
         />
      </div>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.web_viewer.settings.allow_attributes_label' | translate }}</label>
      <div class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width">
         <input
            kendoTextBox
            placeholder="{{ 'brick.brick_definitions.web_viewer.settings.allow_attributes_label' | translate }}"
            fxFlex="1 1 *"
            [value]="allowAttributes$ | async"
            (debouncedInput)="allowAttributesTextChanged($event.target.value)"
            debouncedInputDelay="500"
         />
      </div>
   </div>
</form>
